<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...$$props}
  ><path
    fill="currentColor"
    d="M1.5 12a3.75 3.75 0 0 1 3.75-3.75H7.5l6-4.5v16.5l-6-4.5H5.25A3.75 3.75 0 0 1 1.5 12ZM20.35 5.873l-1.073 1.074a8.195 8.195 0 0 1-.355 10.482l.971 1.165a9.702 9.702 0 0 0 2.607-6.621c0-2.31-.807-4.429-2.15-6.1ZM16.03 10.192c.29.532.47 1.133.47 1.78 0 .699-.204 1.345-.538 1.906l1 1.2A5.203 5.203 0 0 0 18 11.972a5.218 5.218 0 0 0-.868-2.881l-1.102 1.101Z"
  /></svg
>
